"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _FullScreenView = _interopRequireWildcard(require("../../../../Screens/Configurator/Components/FullScreenView"));
var _styles = require("@material-ui/core/styles");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _combineMediaQueries = require("../../../../../Utils/Styles/combineMediaQueries");
var _excluded = ["thumbnailDots"],
  _excluded2 = ["width"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = exports.useStyles = (0, _styles.makeStyles)(function (theme) {
  var _thumbnailGrid;
  return {
    viewsContainer: {
      width: '100%',
      '@media (max-height: 650px)': {
        bottom: 0
      }
    },
    button: _defineProperty({}, theme.breakpoints.down('sm'), {
      bottom: 'auto'
    }),
    thumbnailGrid: (_thumbnailGrid = {
      width: '100%',
      maxWidth: '100%',
      left: 0
    }, _defineProperty(_thumbnailGrid, theme.breakpoints.up('md'), {
      width: '25%',
      left: '50%'
    }), _defineProperty(_thumbnailGrid, theme.breakpoints.up(theme.creator.viewSelectBreakpoint), {
      height: 136 // same as the checkout box
    }), _defineProperty(_thumbnailGrid, theme.breakpoints.down(theme.creator.viewSelectBreakpoint), {
      maxWidth: '100%',
      marginBottom: 0
    }), _defineProperty(_thumbnailGrid, theme.breakpoints.up('lg'), {
      width: 450
    }), _defineProperty(_thumbnailGrid, (0, _combineMediaQueries.combineMediaQueriesWithAnd)(theme.orientation.portrait, theme.breakpoints.down('md')), {
      maxWidth: '100%',
      width: '100%'
    }), _defineProperty(_thumbnailGrid, (0, _combineMediaQueries.combineMediaQueriesWithAnd)(theme.orientation.portrait, theme.breakpoints.up('md')), {
      bottom: 20
    }), _defineProperty(_thumbnailGrid, theme.orientation.portrait, {
      maxWidth: '100%',
      width: '100%'
    }), _defineProperty(_thumbnailGrid, theme.breakpoints.down('xs'), {
      maxWidth: '100%'
    }), _thumbnailGrid)
  };
}, {
  name: 'CreatorFullScreenView'
});
var _default = exports["default"] = function _default(props) {
  var _useStyles = useStyles(props),
    thumbnailDots = _useStyles.thumbnailDots,
    classes = _objectWithoutProperties(_useStyles, _excluded);
  var theme = (0, _styles.useTheme)();
  var renderButtonOnTop = (0, _useMediaQuery["default"])("(max-width : ".concat(theme.creator.viewSelectBreakpoint, "px)"));
  return /*#__PURE__*/_react["default"].createElement(_FullScreenView["default"], _extends({
    classes: classes,
    renderButtonOnTop: renderButtonOnTop,
    renderTopPreviewButton: function renderTopPreviewButton(_ref) {
      var width = _ref.width,
        props = _objectWithoutProperties(_ref, _excluded2);
      return (width === 'xs' || renderButtonOnTop) && /*#__PURE__*/_react["default"].createElement(_FullScreenView.PreviewButton, props);
    },
    thumbnailProps: {
      classes: {
        dots: thumbnailDots
      }
    }
  }, props));
};